// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeProjectsAddProjectsImpactPage_wrapper__aZPnr"};